<div class="price-container" [ngStyle]="{ 'padding': inOnlinePaymentStep() ? '0.5rem' : '0' }">
  @if (!inOnlinePaymentStep()) {
    <h5>{{ 'price' | translate }}: {{ price() | currency: 'EUR' : 'symbol' : '1.2-2' : lang() }}</h5>
    <h4>{{ 'discountedPrice' | translate }}: {{ (onlineDiscountedPrice() || discountedPrice()) | currency: 'EUR' : 'symbol' : '1.2-2' : lang() }}</h4>
    @if (areDifferentRentalPoints()) {
      <h6>{{ 'diffRentalPointSupplement' | translate }}: {{ differentRentalPointsPrice() | currency: 'EUR' : 'symbol' : '1.2-2' : lang() }}</h6>
    }
  } @else {
    <h4>{{ 'bookingHandler.priceToPay' | translate }}: {{ (onlineDiscountedPrice() || discountedPrice()) | currency: 'EUR' : 'symbol' : '1.2-2' : lang() }}</h4>
  }
</div>
